import { get } from '../utils/http';

// 获取发票类型列表
export function getInvoiceTypes() {
  return get('/api/invoice/type')
}

// 获取发票列表
export function getInvoiceList(params: {
  [propName: string]: any
}) {
  return get('/api/invoice', params);
}